import type { Path } from 'react-hook-form';
import { ContactAdAttributes, ContactType } from '@/api/types/ads.types';
import { PresetPhoto, PropertyOption } from '@/api/types/categories.types';
import { ErrorExtension } from '@/api/types/common.types';

export type Collection = {
  [key: string]: string | PropertyOption | undefined;
};

export interface CreateAdFormProps {
  onSubmitError: (errors: CreateAdError[]) => void;
}

export interface EditAdFormProps {
  onSubmitError: (errors: EditAdError[]) => void;
}

export type AdFormFields = {
  categoryId: string;
  collection: Collection;
  boolean: Record<string, boolean | undefined>;
  range: Record<string, string | undefined>;
  regionId: string;
  price: string;
  contact: ContactAdAttributes;
  title: string;
  body: string;
  photoIds: { id: string; src: string }[];
};

export interface AdFormError<NameT extends string = string> {
  name: NameT;
  message: string;
  extensions?: ErrorExtension;
}

export type CreateAdError = AdFormError<Path<AdFormFields>>;
export type EditAdError = AdFormError<Path<EditAdFormFields>>;

export type EditAdFormFields = {
  price: string;
  contactType: ContactType;
  boolean: Record<string, boolean>;
  body: string;
  photoIds: { id: string; src: string }[];
};

export enum PhotoFieldType {
  UploadPhoto,
  PickPresetPhoto,
  Hidden,
}

export interface PhotoFieldState {
  isVisible: boolean;
  presetPhotos: PresetPhoto[] | null;
  sourcePropertyLegacyId?: string | null;
}
